module.exports = __webpack_public_path__ + "img/587624f.webp";